import { Box, Button, Flex, Text, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import InputComponent from "../../components/inputs";
import { CiLock } from "react-icons/ci";
import { useChangePassword } from "../../services/authService";

const CangePassword = ({close, isEnterprise = false}) => {
  const [inputData, setInputData] = useState({ current: "", new: "", confirm: "" });
  const [inputDataErr, setInputDataErr] = useState({
    current: "",
    new: "",
    confirm: "",
  });
  const { changePwrdIsLoading, changePwrdPayload } = useChangePassword((res) => close());

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setInputDataErr({ current: "", new: "", confirm: "" });
    
    // Validation
    let hasError = false;
    const newErrors = { current: "", new: "", confirm: "" };

    if (!inputData.current) {
      newErrors.current = "Current password is required";
      hasError = true;
    }

    if (!inputData.new) {
      newErrors.new = "New password is required";
      hasError = true;
    } else if (inputData.new.length < 6) {
      newErrors.new = "Password must be at least 6 characters";
      hasError = true;
    }

    if (!inputData.confirm) {
      newErrors.confirm = "Please confirm your password";
      hasError = true;
    } else if (inputData.new !== inputData.confirm) {
      newErrors.confirm = "Passwords do not match";
      hasError = true;
    }

    if (hasError) {
      setInputDataErr(newErrors);
      return;
    }

    const payload = {
      current_password: inputData.current,
      new_password: inputData.new,
      confirm_password: inputData.confirm,
    };

    changePwrdPayload(payload);
  };

  return (
    <Box>
      {isEnterprise && (
        <VStack spacing={2} align="stretch" mb={4} p={3} bg="blue.50" borderRadius="md">
          <Text fontSize="sm" fontWeight="600" color="blue.900">
            Enterprise Plan Security Requirement
          </Text>
          <Text fontSize="sm" color="blue.700">
            For security compliance, please change your temporary password to a secure password.
          </Text>
        </VStack>
      )}
      <form onSubmit={handleSubmit}>
        <Flex flexDir={"column"} gap={"14px"}>
          <InputComponent
            containerColor="#fff"
            id={"current_password"}
            isRequired={true}
            icon={<CiLock color="#000" />}
            placeholder={isEnterprise ? "Enter temporary password" : "Current password"}
            value={inputData.current}
            type="password"
            handleChange={(e) =>
              setInputData({ ...inputData, current: e.target.value })
            }
            isInvalid={!!inputDataErr.current}
          />
          {inputDataErr.current && (
            <Text fontSize="sm" color="red.500" mt={-2}>
              {inputDataErr.current}
            </Text>
          )}
          <InputComponent
            containerColor="#fff"
            id={"new_password"}
            isRequired={true}
            icon={<CiLock color="#000" />}
            placeholder={"New password"}
            type="password"
            value={inputData.new}
            handleChange={(e) =>
              setInputData({ ...inputData, new: e.target.value })
            }
            isInvalid={!!inputDataErr.new}
          />
          {inputDataErr.new && (
            <Text fontSize="sm" color="red.500" mt={-2}>
              {inputDataErr.new}
            </Text>
          )}
          <InputComponent
            containerColor="#fff"
            id={"confirm_password"}
            isRequired={true}
            icon={<CiLock color="#000" />}
            type="password"
            placeholder={"Confirm password"}
            value={inputData.confirm}
            handleChange={(e) =>
              setInputData({ ...inputData, confirm: e.target.value })
            }
            isInvalid={!!inputDataErr.confirm}
          />
          {inputDataErr.confirm && (
            <Text fontSize="sm" color="red.500" mt={-2}>
              {inputDataErr.confirm}
            </Text>
          )}
          <Button
            mt={4}
            backgroundColor="#000"
            color={"#fff"}
            type="submit"
            width="full"
            h={"50px"}
            borderRadius={"3px"}
            isLoading={changePwrdIsLoading}
          >
            Submit
          </Button>
        </Flex>
      </form>
    </Box>
  );
};

export default CangePassword;
